import { graphql, useStaticQuery } from 'gatsby'
import React, { useState } from 'react'
import { Container } from 'starterUiComponents'
import { COMPANY_PHONE } from '../../utils/constants'
import {
    AspectRatio,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalOverlay,
    useDisclosure,
} from '@chakra-ui/react'

const BULLETINS_QUERY = graphql`
  query {
    allMysqlBulletin(sort: { fields: [training_video_display_rank, calledby] }) {
      nodes {
        id
        displaytextheader
        dataUrl
        media_type
        calledby
        training_video_display_rank
      }
    }
  }
`

const getYoutubeId = (url) => {
    try {
        const urlObj = new URL(url);
        if (urlObj.pathname.startsWith('/embed/')) {
            return urlObj.pathname.split('/')[2];
        }
    } catch {
        return null;
    }
    return null;
}

const VideoTrainingPage = () => {
    const data = useStaticQuery(BULLETINS_QUERY).allMysqlBulletin.nodes;

    const youtubeVideos = data.filter(
        (item) =>
            item.media_type &&
            item.media_type.toLowerCase() === 'youtube' &&
            getYoutubeId(item.dataUrl)
    )

    const [selectedVideo, setSelectedVideo] = useState(null);
    const { isOpen, onOpen, onClose } = useDisclosure();

    const openVideo = (video) => {
        setSelectedVideo(video)
        onOpen()
    }

    return (
        <Container>
            <h3 className="mb-6">Become a member and get access to hundreds more videos in the Tech Library! Give us a call at {COMPANY_PHONE} and we'll get everything set up.</h3>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                {youtubeVideos.slice(0, 20).map((video) => {
                    const videoId = getYoutubeId(video.dataUrl)
                    const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`

                    return (
                        <div
                            key={video.id}
                            className="cursor-pointer hover:opacity-80"
                            onClick={() => openVideo(video)}
                        >
                            <img
                                src={thumbnailUrl}
                                alt={video.displaytextheader || 'YouTube video'}
                                className="w-full h-auto rounded-lg shadow-md"
                            />
                            <p className="mt-2 text-sm text-center">
                                {video.displaytextheader}
                            </p>
                        </div>
                    )
                })}
            </div>

            {/* Video Modal */}
            <Modal isOpen={isOpen} onClose={onClose} size="6xl">
                <ModalOverlay />
                <ModalContent>
                    <ModalCloseButton />
                    <ModalBody className="flex justify-center">
                        {selectedVideo && (
                            <AspectRatio ratio={16 / 9} w="100%">
                                <iframe
                                    src={selectedVideo.dataUrl}
                                    title={selectedVideo.displaytextheader}
                                    allow="autoplay; encrypted-media"
                                    referrerPolicy="strict-origin-when-cross-origin"
                                    allowFullScreen
                                />
                            </AspectRatio>
                        )}
                    </ModalBody>
                </ModalContent>
            </Modal>
        </Container>
    )
}

export default VideoTrainingPage



